/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mpay.vue?vue&type=template&id=5232a0c5&scoped=true"
import script from "./mpay.vue?vue&type=script&lang=js"
export * from "./mpay.vue?vue&type=script&lang=js"
import style0 from "./mpay.vue?vue&type=style&index=0&id=5232a0c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5232a0c5",
  null
  
)

export default component.exports